import qc from 'qc'
import { getDescendants, getNodeLvl } from '@ps/bridge/qc/node/utils'
import { isDrawLineNode, isGroup, isVideo } from '@ps/bridge/qc/base'
import store from '@ps/store'

// 是否允许渲染虚拟节点
// 隐藏的节点不做渲染
function allowRender(node: qc.Node) {
  const lockedNodeUuids = store.state.workspace.game.lockedNodeUuids
  const lockStatus = lockedNodeUuids.some((id: string) => id === node.uuid)
  return !lockStatus && node.worldVisible
}

/**
 * 重新按照图层层级排序返回新的节点数组
 * 图层规则如下:
 * 1. 参考左侧图层中从上到下排序，越往上层级越高
 * 2. 如果是组节点，则按照 children 的下序进行排序，下序越小越靠前
 * @param node 当前场景节点
 */
export default function (node: qc.Node, renderAll = false): qc.Node[] {
  // 获取所有节点数据
  const nodes = getDescendants(node, false)
  // 临时数组数据
  const tempGroupArr: qc.Node[] = []
  const targetArr: qc.Node[] = []
  const videoArr: qc.Node[] = []
  nodes.forEach((item) => {
    if (!renderAll) {
      // 如果是不允许渲染的节点，则跳过
      if (!allowRender(item)) return
    }
    // 由于视频在最底层，所以单独提取所有视频节点
    if (isVideo(item)) {
      videoArr.push(item)
      return
    }
    // 如果是画线区域的话，组内元素层级更高
    if (!isDrawLineNode(item) && (isGroup(item) || item.children.length > 0)) {
      // 如果目标节点层级不低于临时数据组的层级，则先 pop 到目标数据中再 push
      if (tempGroupArr.length > 0) {
        while (
          tempGroupArr.length > 0 &&
          getNodeLvl(item) <= getNodeLvl(tempGroupArr[tempGroupArr.length - 1])
        ) {
          const groupItem = tempGroupArr.pop() as qc.Node
          targetArr.push(groupItem)
        }
      }
      tempGroupArr.push(item)
    } else {
      // 当存在临时组数据时，先排序组内节点
      if (tempGroupArr.length > 0) {
        const targetGroup = tempGroupArr[tempGroupArr.length - 1]
        // 当前节点是组内节点的话，直接填充到组数据中
        if (targetGroup === item.parent) {
          targetArr.push(item)
        } else {
          // 如果当前节点的父级非场景节点又不是组节点，则轮询把组节点放入数组中
          while (
            item.parent !== tempGroupArr[tempGroupArr.length - 1] &&
            tempGroupArr.length > 0
          ) {
            const groupItem = tempGroupArr.pop() as qc.Node
            targetArr.push(groupItem)
          }
          // 当遍历了所有组节点之后，再把当前节点放入数组中
          targetArr.push(item)
        }
      } else {
        targetArr.push(item)
      }
    }
  })
  // 如果还存在组临时数据，直接赋值给目标数组
  if (tempGroupArr.length > 0) {
    const len = tempGroupArr.length
    for (let i = len - 1; i >= 0; i--) {
      targetArr.push(tempGroupArr.pop() as qc.Node)
    }
  }
  return videoArr.concat(targetArr)
}
